import type { ReactNode } from 'react'

export function SettingsFormFooter({ children }: { children: ReactNode }) {
  return <div className="flex justify-end px-4 py-4">{children}</div>
}
